import * as React from 'react';

export default props => (
    <svg viewBox='0 0 24 24' {...props} fill="#FFFFFF">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M6 6h12v12H6z" />
    </svg>

)
